export default __webpack_public_path__ + "static/media/tarifa.ab7ae74a.jpg";